import {
  IDatePickerStyleProps,
  IDatePickerStyles,
  IStackProps,
  IStyleFunctionOrObject,
} from "@fluentui/react";

export const columnPropsWithHeight150: Partial<IStackProps> = {
  tokens: { childrenGap: 5 },
  styles: { root: { height: 150, marginRight: 10 } },
};

export const textFieldWidth300GrayStyles = {
  fieldGroup: {
    width: "300px",
    backgroundColor: "lightgray", // set the color to a lighter shade of gray
  },
};
export const datePickerStyles: IStyleFunctionOrObject<
  IDatePickerStyleProps,
  IDatePickerStyles
> = {
  textField: {
    "& label": {
      color: "rgb(50, 49, 48)",
    },
    "& input": {
      color: "rgb(50, 49, 48)",
    },
    "& .ms-TextField-fieldGroup": {
      width: "300px",
      borderColor: "rgb(50, 49, 48)",
    },
    "& i": {
      color: "rgb(50, 49, 48)",
    },
  },
};
